import { PaymentType } from 'src/types/order';
import { PAYMENT_TYPE, TRANSACTION_TYPE } from './order';
var isTestingEnv = process.env.NEXT_PUBLIC_ENVIRONMENT == 'testing';
var isDevelopmentEnv = false;
var isStagingEnv = process.env.NEXT_PUBLIC_ENVIRONMENT == 'staging';
var isProductionEnv = !(isDevelopmentEnv || isTestingEnv || isStagingEnv);
var prefixStaging = isStagingEnv && 'STAGING';
var prefixTesting = isTestingEnv && 'TESTING';
var prefixDevelopment = isDevelopmentEnv && 'DEV';
var BANNER_PREFIX = prefixDevelopment || prefixTesting || prefixStaging || '';
var FEATURES = {
  branchSelector: isDevelopmentEnv || isTestingEnv
};
export var commonSettings = {
  BANNER_PREFIX: BANNER_PREFIX,
  isStagingEnv: isStagingEnv,
  isTestingEnv: isTestingEnv,
  isDevelopmentEnv: isDevelopmentEnv,
  isProductionEnv: isProductionEnv,
  FEATURES: FEATURES,
  STAGING_BOOKING_SOURCE_NAMES: ['simplybook_cofitdev'],
  FAVICON_PATH: '/favicon.ico',
  PAYMENT_TYPES: [PAYMENT_TYPE[PaymentType.PAY_IN_FULL], PAYMENT_TYPE[PaymentType.PAY_IN_INSTALLMENTS]],
  SALES_CATEGORIES: ['therapyPurchase', 'therapyGift', 'directPurchase', 'others'],
  BINDING_STATUSES: ['bound', 'notBound'],
  TRANSACTION_TYPE: TRANSACTION_TYPE,
  FOR_PRODUCTS_OTHER_THAN_MEDICINE_BRANCH_ID: 0,
  ADVANCED_GROUP_CLASS_NAME: 'Cofit 進階計畫',
  CUSTOMIZED_PRODUCT_GROUP_CLASS_NAME: '客保',
  CUSTOMIZED_PRODUCT_GROUP_CLASS_REG: /客製化保健品|保健品專案自動開班|客保/,
  AIName: 'NutriGo'
};